import { Col, Menu, Row, Space } from "antd";
import { BarsOutlined, ClusterOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router";
import { IEnvDetails } from "../../types";

export default function EnvironmentSettingsRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("general");
    const { envDetails } = useOutletContext<{ envDetails: IEnvDetails }>();

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[6] || "general");
    }, [location.pathname]);

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                    items={[
                        {
                            key: "general",
                            label: <Space>
                                <BarsOutlined />
                                General
                            </Space>
                        },
                        {
                            key: "infrastructure",
                            label: <Space>
                                <ClusterOutlined />
                                Infrastructure
                            </Space>
                        }
                    ]}
                />
            </Col>
            <Col span={18}>
                <Outlet context={{ envDetails }} />
            </Col>
        </Row >
    );

}